document.addEventListener("DOMContentLoaded", async () => {
	const { loadMoreItems } = await import("@utils/loadMoreItems");
	loadMoreItems(".js-load_more_services");
});
